import { testIdFor } from '@src/components/testId';

function resolve(id: string): HTMLElement | null {
  const control = testIdFor(id, 'control');
  return (
    document.querySelector(`[data-testid="${control}"]`) ??
    document.querySelector(`[data-testid="${id}"]`)
  );
}

/**
 * Enter walks an explicit list of test ids — never tab order, never “whatever
 * is next in the DOM”. The last id is the submit control: Enter on the step
 * before it focuses that button and clicks it when it is enabled.
 * A checkbox on that step checks itself first (Space is still the toggle).
 */
export function useEnterOrder(order: readonly string[]) {
  function advance(from: string) {
    const index = order.indexOf(from);
    const nextId = index >= 0 ? order[index + 1] : undefined;
    if (!nextId) {
      return;
    }

    const next = resolve(nextId);
    if (!next) {
      return;
    }

    next.focus();
    const submits = index + 1 === order.length - 1;
    if (submits && next instanceof HTMLButtonElement && !next.disabled) {
      next.click();
    }
  }

  function bind(id: string) {
    return { onEnter: () => advance(id) };
  }

  return { advance, bind };
}
